import React from 'react';
import { MDCTextField } from '@material/textfield';
import { MDCRipple } from '@material/ripple';
import { MDCTabBar } from '@material/tab-bar';
import { MDCSnackbar } from '@material/snackbar';
import axios from 'axios'

async function pay(way) {
  var amount = Number(document.querySelector("#amountInput").value)
  var promo = document.querySelector("#promoInput").value.trim() || "none"
  if (isNaN(amount)) return snackbar.openText("Введите число")
  if (amount < 1) return snackbar.openText("Минимальная сумма пополнения - 1$")
  if (way == "qiwi")
    var res = await axios.get(`https://nakrutkatop.com:443/api/payments/qiwi?amount=${amount}&promocode=${promo.toUpperCase()}`, { withCredentials: true })
  else if (way == "enot")
    var res = await axios.get(`https://nakrutkatop.com:443/api/payments/enot?amount=${amount}&promocode=${promo.toUpperCase()}`, { withCredentials: true })
    else if (way == "anypay")
    var res = await axios.get(`https://nakrutkatop.com:443/api/payments/anypay?amount=${amount}&promocode=${promo.toUpperCase()}`, { withCredentials: true })
    else if (way == "pprub")
    var res = await axios.get(`https://nakrutkatop.com:443/api/payments/pprub?amount=${amount}&promocode=${promo.toUpperCase()}`, { withCredentials: true })
    else if (way == "ppusd")
    var res = await axios.get(`https://nakrutkatop.com:443/api/payments/ppusd?amount=${amount}&promocode=${promo.toUpperCase()}`, { withCredentials: true })
  
    if (res.data.ok) return window.location.href = res.data.url
  snackbar.openText("Ошибка авторизации")
} 

async function cheque() {
  var code = document.querySelector("#chequeInput").value.trim()
  if (!code) return snackbar.openText("Введите код чека")
  var res = await axios.get(`https://nakrutkatop.com:443/api/payments/cheque?code=${code}`, { withCredentials: true })

  snackbar.openText(res.data.descr)
}

async function check() {
  var res = await axios.get(`https://nakrutkatop.com:443/api/payments/usdt_check`, { withCredentials: true })
  snackbar.openText(res.data.descr)
}

var snackbar

class PayinModal extends React.Component {

  componentDidMount() {
    new MDCTextField(document.querySelector('#amountField'))
    new MDCTextField(document.querySelector('#promoField'))
    new MDCRipple(document.querySelector('#payinBtn'));
    snackbar = new MDCSnackbar(document.querySelector('#payinSnackbarMain'));
    snackbar.openText = function (text) {
      document.querySelector("#payinSnackbar").innerHTML = text
      snackbar.open()
    }
    document.querySelector('#payinBtn').addEventListener("click", () => { pay("enot") })
    const tabBar = new MDCTabBar(document.querySelector('#payWays'));
    tabBar.focusOnActivate = false

    var address = ''
    axios.get(`https://nakrutkatop.com:443/api/payments/usdt_wallet`, { withCredentials: true }).then(res=>address = res.data.address)

    tabBar.listen('MDCTabBar:activated', function (event) {
      var tab_id = event.detail.index
      console.log(tab_id)
      if (tab_id == 0) { // Enot
        document.getElementById("payinBody").innerHTML = `
        <div style="display: flex;">
      
        <label class="mdc-text-field mdc-text-field--outlined" id="amountField" style="width: 100%; margin-right: 4px; display: inline-flex;">
        <input type="number" class="mdc-text-field__input" aria-labelledby="my-label-id" id="amountInput" />
        <span class="mdc-text-field__affix mdc-text-field__affix--suffix">$</span>
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
          <span class="mdc-notched-outline__notch">
            <span class="mdc-floating-label" id="my-label-id">Сумма</span>
          </span>
          <span class="mdc-notched-outline__trailing"></span>
        </span>
      </label>



<label class="mdc-text-field mdc-text-field--outlined" id="promoField" style="width: 100%; margin-left: 4px; display: inline-flex;">
<input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="promoInput" />
<span class="mdc-notched-outline">
  <span class="mdc-notched-outline__leading"></span>
  <span class="mdc-notched-outline__notch">
    <span class="mdc-floating-label" id="my-label-id">Промокод</span>
  </span>
  <span class="mdc-notched-outline__trailing"></span>
</span>
</label>

</div>

      <button class="mdc-button mdc-button--raised"  id="payinBtn" style="width: 100%; height: 56px;">
        <div class="mdc-button__ripple"></div>
        <i class="material-icons mdc-button__icon" aria-hidden="true">account_balance_wallet</i>
        <span class="mdc-button__label">Оплатить</span>
      </button>

      <p id="errField" style="display: none;"></p>
        `
        new MDCTextField(document.querySelector('#amountField'))
        new MDCTextField(document.querySelector('#promoField'))
        new MDCRipple(document.querySelector('#payinBtn'));
        document.querySelector('#payinBtn').addEventListener("click", () => { pay("enot") })
      }

      else if (tab_id == 1) { // PP RUB
        document.getElementById("payinBody").innerHTML = `
        <div style="display: flex;">

        <label class="mdc-text-field mdc-text-field--outlined" id="amountField" style="width: 100%; margin-right: 4px; display: inline-flex;">
        <input type="number" class="mdc-text-field__input" aria-labelledby="my-label-id" id="amountInput" />
        <span class="mdc-text-field__affix mdc-text-field__affix--suffix">$</span>
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
          <span class="mdc-notched-outline__notch">
            <span class="mdc-floating-label" id="my-label-id">Сумма</span>
          </span>
          <span class="mdc-notched-outline__trailing"></span>
        </span>
      </label>

      <label class="mdc-text-field mdc-text-field--outlined" id="promoField" style="width: 100%; margin-left: 4px; display: inline-flex;">
      <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="promoInput" />
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label" id="my-label-id">Промокод</span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>
    </label>

</div>


      <button class="mdc-button mdc-button--raised" id="payinQiwiBtn" style="width: 100%; height: 56px;">
        <div class="mdc-button__ripple"></div>
        <i class="material-icons mdc-button__icon" aria-hidden="true">send</i>
        <span class="mdc-button__label">Оплатить</span>
      </button>

      <p id="errField" style="display: none;"></p>
      `
        new MDCTextField(document.querySelector('#amountField'))
        new MDCTextField(document.querySelector('#promoField'))
        new MDCRipple(document.querySelector('#payinQiwiBtn'));
        document.querySelector('#payinQiwiBtn').addEventListener("click", () => { pay("pprub") })
      } 

      else if (tab_id == 2) { // PP USD
        document.getElementById("payinBody").innerHTML = `
        <div style="display: flex;">
      
        <label class="mdc-text-field mdc-text-field--outlined" id="amountField" style="width: 100%; margin-right: 4px; display: inline-flex;">
        <input type="number" class="mdc-text-field__input" aria-labelledby="my-label-id" id="amountInput" />
        <span class="mdc-text-field__affix mdc-text-field__affix--suffix">$</span>
        <span class="mdc-notched-outline">
          <span class="mdc-notched-outline__leading"></span>
          <span class="mdc-notched-outline__notch">
            <span class="mdc-floating-label" id="my-label-id">Сумма</span>
          </span>
          <span class="mdc-notched-outline__trailing"></span>
        </span>
      </label>



<label class="mdc-text-field mdc-text-field--outlined" id="promoField" style="width: 100%; margin-left: 4px; display: inline-flex;">
<input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="promoInput" />
<span class="mdc-notched-outline">
  <span class="mdc-notched-outline__leading"></span>
  <span class="mdc-notched-outline__notch">
    <span class="mdc-floating-label" id="my-label-id">Промокод</span>
  </span>
  <span class="mdc-notched-outline__trailing"></span>
</span>
</label>

</div>

      <button class="mdc-button mdc-button--raised"  id="payinPPBtn" style="width: 100%; height: 56px;">
        <div class="mdc-button__ripple"></div>
        <i class="material-icons mdc-button__icon" aria-hidden="true">account_balance_wallet</i>
        <span class="mdc-button__label">Оплатить</span>
      </button>

      <p id="errField" style="display: none;"></p>
        `
        new MDCTextField(document.querySelector('#amountField'))
        new MDCTextField(document.querySelector('#promoField'))
        new MDCRipple(document.querySelector('#payinPPBtn'));
        document.querySelector('#payinPPBtn').addEventListener("click", () => { pay("ppusd") })
      }

      else if (tab_id == 3) { // USDT
        document.getElementById("payinBody").innerHTML = `
      <label class="mdc-text-field mdc-text-field--outlined" id="chequeField" style="width: 100%;">
      <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="chequeInput" disabled value="${address}"/>
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label" id="my-label-id">Адрес для перевода</span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>
    </label>

    <button class="mdc-button mdc-button--raised" id="acceptBtn" style="width: 100%; display: inline-flex; height: 56px">
      <div class="mdc-button__ripple"></div>
      <i class="material-icons mdc-button__icon" aria-hidden="true">done</i>
      <span class="mdc-button__label">Проверить перевод</span>
    </button>

    <p id="errField" style="display: none;"></p>
      `
        new MDCTextField(document.querySelector('#chequeField'))
        new MDCRipple(document.querySelector('#acceptBtn'));
        document.querySelector('#acceptBtn').addEventListener("click", () => { check() })
      }

      else if (tab_id == 4) { // Помокод
        document.getElementById("payinBody").innerHTML = `
      <label class="mdc-text-field mdc-text-field--outlined" id="chequeField" style="width: 100%;">
      <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="chequeInput" />
      <span class="mdc-notched-outline">
        <span class="mdc-notched-outline__leading"></span>
        <span class="mdc-notched-outline__notch">
          <span class="mdc-floating-label" id="my-label-id">Чек</span>
        </span>
        <span class="mdc-notched-outline__trailing"></span>
      </span>
    </label>

    <button class="mdc-button mdc-button--raised" id="acceptBtn" style="width: 100%; display: inline-flex; height: 56px">
      <div class="mdc-button__ripple"></div>
      <i class="material-icons mdc-button__icon" aria-hidden="true">done</i>
      <span class="mdc-button__label">Применить</span>
    </button>

    <p id="errField" style="display: none;"></p>
      `
        new MDCTextField(document.querySelector('#chequeField'))
        new MDCRipple(document.querySelector('#acceptBtn'));
        document.querySelector('#acceptBtn').addEventListener("click", () => { cheque() })
      }
    })

  }

  render() {
    return <div className="modal fade" id="payinModal" tabIndex="-1" role="dialog" aria-labelledby="payinModal"
      aria-hidden="true" ><div class="mdc-snackbar" id="payinSnackbarMain">
        <div class="mdc-snackbar__surface">
          <div class="mdc-snackbar__label"
            role="status"
            aria-live="polite" id="payinSnackbar">

          </div>
          <div class="mdc-snackbar__actions">
            <button type="button" class="mdc-button mdc-snackbar__action">
              <div class="mdc-button__ripple"></div>
              <span class="mdc-button__label">Закрыть</span>
            </button>
          </div>
        </div>
      </div>
      <div className="modal-dialog" role="document" style={{maxWidth: 700}}>
        <div className="modal-content">
          <div className="modal-header" style={{ paddingBottom: "8px" }}>
            <h5 className="modal-title" id="exampleModalLabel1">Пополнение баланса</h5>
          </div>
          <div className="modal-body" style={{ paddingTop: "0px" }}>
            <div className="mdc-tab-bar" role="tablist" id="payWays">
              <div className="mdc-tab-scroller">
                <div className="mdc-tab-scroller__scroll-area">
                  <div className="mdc-tab-scroller__scroll-content" style={{flexWrap: 'wrap', maxWidth: '100%'}}>
                    <button className="mdc-tab mdc-tab--active" role="tab" aria-selected="false" tabindex="-1">
                      <span className="mdc-tab__content">
                        <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-credit-card fa-xs"></i> </span>
                        <span className="mdc-tab__text-label ">Enot</span>
                      </span>
                      <span className="mdc-tab-indicator mdc-tab-indicator--active">
                        <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                      </span>
                      <span className="mdc-tab__ripple"></span>
                    </button>


                    <button className="mdc-tab" role="tab" aria-selected="false" tabindex="-1">
                      <span className="mdc-tab__content">
                        <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-wallet fa-xs"></i> </span>
                        <span className="mdc-tab__text-label">PayPalych RUB</span>
                      </span>
                      <span className="mdc-tab-indicator">
                        <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                      </span>
                      <span className="mdc-tab__ripple"></span>
                    </button>

                      <button className="mdc-tab" role="tab" aria-selected="false" tabindex="-1">
                      <span className="mdc-tab__content">
                        <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-wallet fa-xs"></i> </span>
                        <span className="mdc-tab__text-label">PayPalych USD</span>
                      </span>
                      <span className="mdc-tab-indicator">
                        <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                      </span>
                      <span className="mdc-tab__ripple"></span>
                    </button>

                      <button className="mdc-tab" role="tab" aria-selected="false" tabindex="-1">
                      <span className="mdc-tab__content">
                        <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-wallet fa-xs"></i> </span>
                        <span className="mdc-tab__text-label">USDT (TRC-20)</span>
                      </span>
                      <span className="mdc-tab-indicator">
                        <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                      </span>
                      <span className="mdc-tab__ripple"></span>
                    </button>

                    <button className="mdc-tab" role="tab" aria-selected="false" tabindex="-1">
                      <span className="mdc-tab__content">
                        <span className="mdc-tab__icon" aria-hidden="true"><i className="fas fa-gift fa-xs"></i> </span>
                        <span className="mdc-tab__text-label">Чек</span>
                      </span>
                      <span className="mdc-tab-indicator">
                        <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                      </span>
                      <span className="mdc-tab__ripple"></span>
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div style={{ marginTop: "16px" }} id="payinBody">

              <div style={{ width: "50%", display: "inline-flex" }}>
                <label class="mdc-text-field mdc-text-field--outlined" id="amountField" style={{ width: "100%", display: "inline-flex", marginRight: "4px" }}>
                  <input type="number" class="mdc-text-field__input" aria-labelledby="my-label-id" id="amountInput" />
                  <span class="mdc-text-field__affix mdc-text-field__affix--suffix">$</span>
                  <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__notch">
                      <span class="mdc-floating-label" id="my-label-id">Сумма</span>
                    </span>
                    <span class="mdc-notched-outline__trailing"></span>
                  </span>
                </label>
              </div>
              <div style={{ width: "50%", height: "56px", display: "inline-flex" }}>
                <label class="mdc-text-field mdc-text-field--outlined" id="promoField" style={{ width: "100%", display: "inline-flex", marginLeft: "4px" }}>
                  <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="promoInput" />
                  <span class="mdc-notched-outline">
                    <span class="mdc-notched-outline__leading"></span>
                    <span class="mdc-notched-outline__notch">
                      <span class="mdc-floating-label" id="my-label-id">Промокод</span>
                    </span>
                    <span class="mdc-notched-outline__trailing"></span>
                  </span>
                </label>
              </div>
              
              <button class="mdc-button mdc-button--raised" id="payinBtn" style={{ width: "100%", display: "inline-flex", height: "56px" }}>
                <div class="mdc-button__ripple"></div>
                <i class="material-icons mdc-button__icon" aria-hidden="true">account_balance_wallet</i>
                <span class="mdc-button__label">Оплатить</span>
              </button>

              <p id="errField" style={{ display: "none" }}></p>
            </div>


          </div>
        </div>
      </div>
    </div>
  }
}

export default PayinModal